import React, {Component} from "react";
import {Button, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import Dropdown from "../../../common/Dropdown/Dropdown";
import Loading from "../../../common/Loading/Loading";
import ApiProductsService from "../../../services/api-products-service";
import toastr from "toastr";
import ToastOptions from "../../../common/toast/toastr-config";

export class AddApiService extends Component {
    constructor(props) {
        super(props);
        this.state = {
            services: [],
            nameInvalid: true,
            newServiceName: "",
            newSelectedService: ""
        }
    }

    cancelAction = () => {
        this.setState({
            nameInvalid: true,
            newServiceName: "",
            newSelectedService: ""
        })
        this.fetchServices();
        this.props.cancelAction();
    }


    render() {
        return (
            <div>
                <Modal isOpen={this.props.isAddServiceModalVisible} size="lg">
                    <ModalHeader toggle={() => this.cancelAction()}>
                        Add Service
                    </ModalHeader>
                    {(
                        <ModalBody>
                            <FormGroup className="custom_form name-container">
                                {this.state.newServiceName !== "" && (
                                    <Label
                                        for="aname"
                                        className={
                                            this.state.nameInvalid ? "invalid" : ""
                                        }
                                    >
                                        Name
                                    </Label>
                                )}
                                <Input
                                    type="name"
                                    name="name"
                                    id="name"
                                    placeholder="Name"
                                    value={this.state.newServiceName}
                                    onChange={e => this.validateName(e)}
                                    invalid={this.state.nameInvalid}
                                    maxLength="32"
                                    autoComplete="off"
                                />
                                <FormFeedback>
                                    {this.state.nameInvalid ? "Name is required" : ""}
                                </FormFeedback>
                            </FormGroup>
                            <FormGroup>
                                <span className="product-id-label">Product ID</span>
                                <Dropdown
                                    options={this.state.services}
                                    changeSelectedOption={this.selectService}
                                />
                            </FormGroup>
                        </ModalBody>
                    )}

                    {this.state.isDialogLoading && (
                        <ModalBody className="loading-body">
                            <Loading/>
                        </ModalBody>
                    )}
                    <ModalFooter>
                        <Button
                            color="btn btn-link"
                            onClick={() => {
                                this.cancelAction();
                            }}
                        >
                            Cancel
                        </Button>
                        <button
                            type="button"
                            className="btn btn-success submit-user-button"
                            invalid={this.state.nameInvalid}
                            onClick={() => this.addService()}
                        >
                            Save
                        </button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }

    validateName = (e) => {
        let invalidName = false;
        if (e.target.value === "") {
            invalidName = true;
        }
        this.setState({
            newServiceName: e.target.value,
            nameInvalid: invalidName
        })
    }

    selectService = (selected) => {
        this.setState({
            newSelectedService: selected
        })
    }

    addService = () => {
        let service = {
            serviceName: this.state.newSelectedService,
            displayName: this.state.newServiceName
        }
        this.props.addApiService(service);
        this.cancelAction();
    }

    componentDidMount() {
        this.fetchServices();
    }


    /**
     * Fetch all the possible Services
     * @returns {Promise<void>}
     */
    fetchServices = async () => {
        try {
            const response = await ApiProductsService.getApigeeServices();

            let services = response.data.map(s => s.name);
            if (services && services.length > 0) {
                if (this.props.product.services) {
                    //Remove any services already added to this product
                    services = services.filter(s => !this.props.product.services.map(ps => ps.serviceName).includes(s))
                }
                this.setState({
                    services: services,
                    newSelectedService: services[0]
                });
            }
        } catch (error) {
            toastr.options = ToastOptions;
            toastr.error(error.message);
        }
    };
}


// WEBPACK FOOTER //
// ./src/products/product-details/components/AddApiService.js